import "core-js/modules/es.regexp.exec.js";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _Array$from from "@babel/runtime-corejs3/core-js-stable/array/from";
import _Symbol from "@babel/runtime-corejs3/core-js-stable/symbol";
import _getIteratorMethod from "@babel/runtime-corejs3/core-js/get-iterator-method";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _createForOfIteratorHelper(r, e) {
  var t = void 0 !== _Symbol && _getIteratorMethod(r) || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = function (r, a) {
      if (r) {
        var _context4;
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = _sliceInstanceProperty(_context4 = {}.toString.call(r)).call(_context4, 8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? _Array$from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
      }
    }(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function () {};
      return {
        s: F,
        n: function () {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function (r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function () {
      t = t.call(r);
    },
    n: function () {
      var r = t.next();
      return a = r.done, r;
    },
    e: function (r) {
      u = !0, o = r;
    },
    f: function () {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
import _flatMapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/flat-map";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _Object$fromEntries from "@babel/runtime-corejs3/core-js-stable/object/from-entries";
import _Object$entries from "@babel/runtime-corejs3/core-js-stable/object/entries";
import { useCallback, useMemo } from "react";
import get from "lodash/get";
export var getListOfPaths = function getListOfPaths(uiProps) {
  var _context;
  return Array.isArray(uiProps.content) ? _flatMapInstanceProperty(_context = uiProps.content).call(_context, function (item) {
    return Array.isArray(item.content) ? getListOfPaths(item) : get(item, ["componentProps", "path"], []);
  }) : [];
};
var getMetadataValueByPath = function getMetadataValueByPath(uiProps, path, metadataKey) {
    if (Array.isArray(uiProps.content)) {
      var _step,
        _iterator = _createForOfIteratorHelper(uiProps.content);
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (Array.isArray(item.content)) return getMetadataValueByPath(item, path, metadataKey);
          if (get(item, ["componentProps", "path"]) === path) return get(item, metadataKey, path);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return path;
  },
  getMessagesWithId = function (messages, fieldId) {
    return _mapInstanceProperty(messages).call(messages, function (val) {
      return _objectSpread(_objectSpread({}, val), {}, {
        fieldId: fieldId
      });
    });
  };
export var useGetLabelMap = function (uiProps, translator) {
  var labelsMapWithIds = useMemo(function () {
      var _context2;
      return _reduceInstanceProperty(_context2 = getListOfPaths(uiProps)).call(_context2, function (acc, path) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, path, {
          label: translator(getMetadataValueByPath(uiProps, path, ["componentProps", "label"])),
          fieldId: translator(getMetadataValueByPath(uiProps, path, "id"))
        }));
      }, {});
    }, [translator, uiProps]),
    getMessagesWithLabelsMap = useCallback(function () {
      var _context3,
        type = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return _Object$fromEntries(_mapInstanceProperty(_context3 = _Object$entries(type)).call(_context3, function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          path = _ref2[0],
          val = _ref2[1];
        return [labelsMapWithIds[path].label, getMessagesWithId(val, labelsMapWithIds[path].fieldId)];
      }));
    }, [labelsMapWithIds]);
  return getMessagesWithLabelsMap;
};